import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=2b4991bc&scoped=true"
import script from "./icon-button.vue?vue&type=script&lang=ts"
export * from "./icon-button.vue?vue&type=script&lang=ts"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=2b4991bc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4991bc",
  null
  
)

export default component.exports